import { ReactElement } from 'react';

interface IConditionalTabWrapperProps {
  children: ReactElement;
  condition: boolean;
  fallback: ReactElement | null;
  skip?: boolean;
}

const ConditionalTabWrapper = (props: IConditionalTabWrapperProps) => {
  const {
    children, condition, fallback, skip = false,
  } = props;

  if (skip) return null;
  if (!condition) return fallback;

  return children;
};

export default ConditionalTabWrapper;
